/**
 * @generated SignedSource<<5a920244c1540ed3d30610e981e605f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_viewer$data = {
  readonly shareJewelryItemTooltip?: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedIconBubbleEmail_viewer">;
  readonly " $fragmentType": "PdpRespIconBubbles_viewer";
};
export type PdpRespIconBubbles_viewer$key = {
  readonly " $data"?: PdpRespIconBubbles_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_viewer"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "shareJewelryItemTooltip",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "shareJewelryItemTooltip"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"shareJewelryItemTooltip\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5dc990bbd271519b2ed6211c9ec71831";

export default node;
